import React from 'react';
import PropTypes from 'prop-types';
import { InfoTooltip } from 'framework-ui-components';
import { Button } from 'framework-ui-components/Components/V2';
import StatoDichiarazione from 'enums/StatoDichiarazione';

const AzioneCambioStato = (props) => {
  const {
    dichiarazioniSelezionate,
    statoDestinazione,
    apriModaleCambioStato,
  } = props;

  const nomeStatoDestinazione = StatoDichiarazione.stringify(statoDestinazione);

  const filtraDichiarazioniSelezionate = (dichiarazioniSelezionate, statoDestinazione) => {
    switch (statoDestinazione) {
      case StatoDichiarazione.InLavorazione:
        return dichiarazioniSelezionate.filter((d) => d.Stato != StatoDichiarazione.InLavorazione
          && d.Stato != StatoDichiarazione.RifiutataINPS);
      case StatoDichiarazione.Completa:
        return dichiarazioniSelezionate.filter((d) => d.Stato != StatoDichiarazione.Completa
          && !d.HaErrori);
      default:
        return [];
    }
  };

  const abilitaSpostamentoStato = (dichiarazioniSelezionate, statoDestinazione) => {
    const dichiarazioniSpostabili = filtraDichiarazioniSelezionate(dichiarazioniSelezionate, statoDestinazione);
    let messaggio = '';

    if (dichiarazioniSpostabili.length == 0) {
      messaggio = dichiarazioniSelezionate.length == 1
        ? `La dichiarazione selezionata non e' spostabile nello stato \"${nomeStatoDestinazione}\"`
        : `Nessuna delle dichiarazioni selezionate e' spostabile nello stato \"${nomeStatoDestinazione}\"`;
    } else if (dichiarazioniSpostabili.length < dichiarazioniSelezionate.length) {
      messaggio = `Alcune dichiarazioni non possono essere spostate nello stato \"${nomeStatoDestinazione}\"`;
    }

    return {
      disabled: dichiarazioniSpostabili.length == 0,
      showInfo: messaggio.length > 0,
      infoContent: messaggio,
    };
  };

  const {
    disabled,
    showInfo,
    infoContent,
  } = abilitaSpostamentoStato(dichiarazioniSelezionate, statoDestinazione);

  return (
    <Button
      key={`PassaA${statoDestinazione}`}
      disabled={disabled}
      onClick={() => apriModaleCambioStato()}
    >
      {`Imposta come "${nomeStatoDestinazione}"`}
      {showInfo && (
        <InfoTooltip left>
          {infoContent}
        </InfoTooltip>
      )}
    </Button>
  );
};

AzioneCambioStato.propTypes = {
  dichiarazioniSelezionate: PropTypes.array.isRequired,
  statoDestinazione: PropTypes.number.isRequired,
  apriModaleCambioStato: PropTypes.func.isRequired,
};

export default AzioneCambioStato;
